import React from 'react';
import PropTypes from 'prop-types';
import DashboardProfile from './DashboardProfile';
import DashboardProducts from './DashboardProducts';
import DashboardBookings from './DashboardBookings';
import DashboardEngagement from './DashboardEngagement';
import TabGroup from './ui/TabGroup';

class Dashboard extends React.Component{

    state = {
        currentTab: 'Engagement'
    };

    changeTab = (currentTab) => {
        this.setState({ currentTab });
    };

    printPage = () => {
        this.changeTab('Bookings');
        setTimeout(() => {
            window.print();
        }, 500);
    };

    renderTabPanels = (user) => {
        switch(this.state.currentTab) {
            case 'Engagement':
                return <DashboardEngagement user={user} payments={this.props.payments}/>
            case 'Products':
                return <DashboardProducts user={user} products={this.props.products} renderTags={this.props.renderTags} addTags={this.props.addTags} removeTags={this.props.removeTags} filterProducts={this.props.filterProducts} userProductSearch={this.props.userProductSearch}/>
            case 'Bookings':
                return <DashboardBookings user={user} appts={this.props.appts}/>
            default:
                return null;
        }
    };

    render() {
        const user = this.props.user;
        return (
            <div className="dashboard">
                <a className="no-print print-btn" onClick={ e => { this.printPage() } }><i className="material-icons">print</i></a>
                <DashboardProfile user={user} freshdeskID={this.props.freshdeskID}/>
                <div className="profile-tabs">
                    <div className="no-print">
                        <TabGroup tabs={['Engagement', 'Products', 'Bookings']} currentTab={this.state.currentTab} onChange={this.changeTab} />
                    </div>
                    {this.renderTabPanels(user)}
                </div>
            </div>
        );
    }
}

Dashboard.propTypes = {
    user: PropTypes.object.isRequired,
    userProductSearch: PropTypes.string.isRequired,
    products: PropTypes.object.isRequired,
    renderTags: PropTypes.func.isRequired,
    addTags: PropTypes.func.isRequired,
    removeTags: PropTypes.func.isRequired,
    filterProducts: PropTypes.func.isRequired,
    appts: PropTypes.array.isRequired,
    freshdeskID: PropTypes.string
}

export default Dashboard;


/** WEBPACK FOOTER **
 ** ./src/components/Dashboard.js
 **/